import React from 'react';
import { useDropzone } from 'react-dropzone';
import IconAttachment from '../IconAttachment/IconAttachment';
import { isArrayLength } from '../../util/genericHelpers';

const maxSize = 20 * 1024 * 1024; // 20MB in bytes

function DropZone(props) {
  const { onAttachmentUpload } = props;

  const onDrop = (acceptedFiles, rejectedFiles) => {
    // Handling accepted files
    if (isArrayLength(acceptedFiles))
      acceptedFiles.forEach(file => {
        onAttachmentUpload(file);
      });
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/*': [],
    },
    maxSize: maxSize,
    onDrop,
  });

  return (
    <div {...getRootProps({ className: 'dropzone' })}>
      <input {...getInputProps()} />
      <IconAttachment />
    </div>
  );
}
export default DropZone;
